<template>
  <div>
    {{ formatCurrency(object.cost_branch) }}
    <a class="ml-1"
       v-if="hasAdditionalInfo"
       :id="`popover-service-${object.id}`">
      <InfoSvg/>
    </a>

    <CustomPopover :target="`popover-service-${object.id}`"
                   ref="popover"
                   triggers="hover"
                   placement="top"
                   :arrow="false"
                   custom-class="record-popover">

      <div class="d-flex flex-column gap-2">

        <div v-if="packageCost > 0">
          <div class="form-label mb-0">{{ $t('packages_cost') }}:</div>
          <div>{{ formatCurrency(packageCost) }}</div>
        </div>

        <div v-if="materialsCost > 0">
          <div class="form-label mb-0">{{ $t('materials_cost') }}:</div>
          <div>{{ formatCurrency(materialsCost) }}</div>
        </div>

        <div v-if="object.technics && object.technics.length > 0">
          <div class="form-label mb-0">{{ $t('technic_reward') }}:</div>
          <div v-for="item in object.technics" :key="`o-t-${item.id}`">
            {{ item.lname }}: {{ formatCurrency(getReward(item)) }}
          </div>
        </div>

        <div v-if="object.doctors && object.doctors.length > 0">
          <div class="form-label mb-0">{{ $t('doctor_reward') }}:</div>
          <div v-for="item in object.doctors" :key="`o-d-${item.id}`">
            {{ item.lname }}: {{ formatCurrency(getReward(item)) }}
          </div>
        </div>

        <div v-if="object.managers && object.managers.length > 0">
          <div class="form-label mb-0">{{ $t('manager_reward') }}:</div>
          <div v-for="item in object.managers" :key="`o-m-${item.id}`">
            {{ item.lname }}: {{ formatCurrency(getReward(item)) }}
          </div>
        </div>

        <div v-if="object.assistants && object.assistants.length > 0">
          <div class="form-label mb-0">{{ $t('assistant_reward') }}:</div>
          <div v-for="item in object.assistants" :key="`o-assistant-${item.id}`">
            {{ item.lname }}: {{ formatCurrency(getReward(item)) }}
          </div>
        </div>

        <div v-if="object.curators && object.curators.length > 0">
          <div class="form-label mb-0">{{ $t('curator_reward') }}:</div>
          <div v-for="item in object.curators" :key="`o-curator-${item.id}`">
            {{ item.lname }}: {{ formatCurrency(getReward(item)) }}
          </div>
        </div>

      </div>

    </CustomPopover>

  </div>
</template>

<script>

import InfoSvg from '@/assets/svg-vue/general/info.svg'
import {formatCurrency} from "@/extensions/filters/filters"
import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"

export default {
  name: "ServicesDatatableTDCost",
  components: {
    CustomPopover,
    InfoSvg,
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    hasAdditionalInfo() {
      return this.materialsCost > 0 || this.packageCost > 0
          || (this.object.technics || []).length > 0
          || (this.object.doctors || []).length > 0
          || (this.object.managers || []).length > 0
    },
    packageCost() {
      return this.object.packages ? this.object.packages.reduce((acc, cur) => acc + cur.cost, 0) : 0
    },
    materialsCost() {
      const fixedCost = Number(this.object?.materials_fixed_cost || 0)
      const variableCost = Number((this.object?.materials || []).reduce((acc, cur) => acc + cur.price, 0))
      return variableCost + fixedCost
    }
  },
  methods: {
    formatCurrency,
    getReward(item) {
      if(item.pivot.value) return item.pivot.value
      if(Number(item.pivot.absolute) > 0) return item.pivot.absolute
      return (item.pivot.percent * this.object.cost) / 100
    }
  }
}
</script>
